import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=46f736b7&scoped=true&"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js&"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js&"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=46f736b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f736b7",
  null
  
)

export default component.exports